import React from 'react';
import Loading from 'components/pure/utils/Loading';
import './LoadingOverlay.styl';

export default class LoadingOverlay extends React.PureComponent {
  render() {
    return (
      <div className="loading-overlay" onClick={e => e.stopPropagation()}>
        <Loading />
        {this.props.label && <div className="label">{this.props.label}</div>}
        <div className="dimming-overlay" />
      </div>
    );
  }
}
